// src/store/creditsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../utils";

// Configurable top-up buttons
const FIXED_AMOUNTS = [20, 100, 250, 500, 1000];

// Fetch wallet balance + history
export const fetchCredits = createAsyncThunk(
    "credits/fetchCredits",
    async () => {
        const res = await apiFetch("auth/wallet");
        const data = await res.json();

        const wallet = data.walletBalance;

        const formattedBalance = Number(wallet).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return {
            balance: formattedBalance,
            history: data.recentActivity,
        };
    }
);

const creditsSlice = createSlice({
    name: "credits",
    initialState: {
        balance: 0,
        history: [],
        fixedAmounts: FIXED_AMOUNTS,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch credits
            .addCase(fetchCredits.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCredits.fulfilled, (state, action) => {
                state.balance = action.payload.balance;
                state.history = action.payload.history;
                state.loading = false;
            })
            .addCase(fetchCredits.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default creditsSlice.reducer;
export { FIXED_AMOUNTS };
